import type { SyncboxEmailDraft, SyncboxEmailDraftParams } from "@/schema"

import { ApiContext, apiContextFetch } from "@/hooks/api/base"

export interface SyncboxEmailDraftsResponse {
  email_drafts: SyncboxEmailDraft[]
}

export interface SyncboxEmailDraftOwner {
  householdId?: string
  contactId?: string
  businessId?: string
}

export function fetchSyncboxEmailDrafts(context: ApiContext, owner: SyncboxEmailDraftOwner) {
  const params = new URLSearchParams()

  if (owner.householdId) {
    params.append("household_id", owner.householdId)
  } else if (owner.contactId) {
    params.append("contact_id", owner.contactId)
  } else if (owner.businessId) {
    params.append("business_id", owner.businessId)
  }

  return apiContextFetch<SyncboxEmailDraftsResponse>(context, `syncbox/email_drafts?${params.toString()}`)
}

export function fetchSyncboxEmailDraft(context: ApiContext, id: string) {
  return apiContextFetch<SyncboxEmailDraft>(context, `syncbox/email_drafts/${id}`)
}

export function createSyncboxEmailDraft(
  context: ApiContext,
  emailDraft: SyncboxEmailDraftParams,
  templateAttachmentSignedIds?: string[]
) {
  return apiContextFetch<SyncboxEmailDraft>(context, "syncbox/email_drafts", {
    method: "POST",
    body: JSON.stringify({
      email_draft: emailDraft,
      template_attachment_signed_ids: templateAttachmentSignedIds,
    }),
  })
}

export function updateSyncboxEmailDraft(
  context: ApiContext,
  id: string,
  emailDraft: SyncboxEmailDraftParams,
  templateAttachmentSignedIds?: string[]
) {
  return apiContextFetch<SyncboxEmailDraft>(context, `syncbox/email_drafts/${id}`, {
    method: "PATCH",
    body: JSON.stringify({
      email_draft: emailDraft,
      template_attachment_signed_ids: templateAttachmentSignedIds,
    }),
  })
}

export function deleteSyncboxEmailDraft(context: ApiContext, id: string) {
  return apiContextFetch<void>(context, `syncbox/email_drafts/${id}`, {
    method: "DELETE",
  })
}
